export default "__VITE_ASSET__hO4dd8ILk$iZF7aFIOUkdg__";